export const SELECT_ALL_VALUE = "all";
export const NO_LEAGUE_ID = "competitions-without-league";
